import { gql } from "graphql-tag"

const typePrice = gql`
  type Tier {
    minimumQuantity: Int
    value: PriceValue
  }

  type ListPrice {
    id: ID
    active: Boolean
    key: String
    lastMessageSequenceNumber: Int
    sku: String
    value: PriceValue
    version: Int
    tiers: [Tier]
  }

  type PriceValue {
    type: String
    currencyCode: String
    fractionDigits: Int
    centAmount: Int
    preciseAmount: Int
  }

  type articlePurchasePrice {
    value: Float
    sku: String
  }
  type articleGrossSellingPrice {
    value: Float
    sku: String
  }

  type OldPrice {
    sku: String
    orderNumber: String
    price: Float
    discount: Float
    discountPrice: Float
    orderDate: String
    customerOrderText: String
  }

  type ListPrices {
    total: Int
    items: [ListPrice]
    articlePurchasePrices: [articlePurchasePrice]
    articleGrossSellingPrices: [articleGrossSellingPrice]
    oldPrices: [OldPrice]
  }

  input SkuItemsDraft {
    sku: String
  }

  type Query {
    skuListPrices(items: [SkuItemsDraft]): ListPrices
    skuCustomerPrices(
      customerId: ID
      customerNumber: String
      customerKey: String
      sku: [String]
      country: String
    ): ListPrices
    skuCustomerPrice(customerId: ID, sku: String, locale: String, customerNumber: String): ListPrice
  }
`

export { typePrice }

export default typePrice
